import TestimonialsGridBlock from '../common/blocks/TestimonialsGridBlock';
const Staff = () => {
	return (
		<TestimonialsGridBlock/>	
	);
};
export default Staff;